import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { RktFormComponent, formRow, formTextarea } from '@rocketfinancialcorp/rocket-ui/form';

import { AbstractMoveMoneyBase } from '@shared/components';
import { FormModel, MoveWireDetails } from '@shared/models';

@Component({
  selector: 'app-move-wire-selection',
  templateUrl: './move-wire-selection.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, RktFormComponent],
})
export class MoveWireSelectionComponent implements AfterViewChecked {
  @Output() changed = new EventEmitter<MoveWireDetails>();

  @Output() blurred = new EventEmitter<boolean>();

  wireDetailsForm = new FormGroup({});

  wireDetailsField: FormlyFieldConfig[] = [
    formRow([
      formTextarea({
        key: 'narrative',
        label: 'Narrative',
        className: 'wire-details-field',
        props: {
          required: true,
          minLength: 1,
          maxLength: 1024,
          withCounter: true,
        },
      }),
    ]),
    formRow([
      formTextarea({
        key: 'memo',
        label: 'Memo',
        className: 'wire-details-field',
        props: {
          maxLength: 1024,
          withCounter: true,
          blur: () => this.onWireDetailsBlur(),
        },
      }),
    ]),
  ];

  wireDetailsModel: FormModel<{
    narrative?: string;
    memo?: string;
  }> = {
    narrative: undefined,
    memo: undefined,
  };

  constructor(
    public ref: ChangeDetectorRef,
    private moveMoneyService: AbstractMoveMoneyBase,
  ) {}

  ngAfterViewChecked(): void {
    this.ref.detectChanges();
  }

  setInitialValues() {
    const { narrative, memo } = this.moveMoneyService.wireDetails || {};

    this.wireDetailsModel = {
      ...this.wireDetailsModel,
      narrative,
      memo,
    };
  }

  onWireDetailsChange(): void {
    this.changed.emit({
      narrative: this.wireDetailsModel.narrative,
      memo: this.wireDetailsModel.memo,
    });
  }

  onWireDetailsBlur(): void {
    this.blurred.emit(true);
  }

  resetValue(): void {
    this.wireDetailsForm.reset();
    this.onWireDetailsChange();
  }
}
